var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTripadvisorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 63.997 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.568111 0 0 .568111 -18.190262 12.840025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.28 0C73.612 0 60.36 3.694 49.91 10.523l-17.58.016s4.148 5.537 5.494 11.12L82.318 55.8l5.972 8.928 6.03-9.004 44.596-34.088c1.324-5.62 5.52-11.23 5.52-11.23l-18.734-.013C115.194 3.603 102.424 0 88.278 0z",
    fill: "#000a12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.484 10.318a28.015 28.015 0 0 0-8.839 1.695 27.91 27.91 0 0 0-15.777 14.603c-1.418 3.075-2.22 6.326-2.475 9.597C87.35 21.873 75.515 10.497 60.98 10.2c8.04-3.44 17.278-5.3 27.29-5.3 10.08 0 19.18 1.817 27.213 5.418",
    fill: "#fcc40f"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000a12"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 25.132,
    cy: 39.396,
    cx: 60.072,
    fill: "#fff",
    strokeWidth: 5.847
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.3,
    cy: 39.396,
    cx: 60.072,
    fill: "none",
    strokeWidth: 5.102
  })), /*#__PURE__*/React.createElement("circle", {
    r: 4.667,
    cy: 39.396,
    cx: 60.072,
    fill: "#ef6a45"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000a12"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 25.132,
    cy: 39.346,
    cx: 116.615,
    fill: "#fff",
    strokeWidth: 5.847
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.3,
    cy: 39.346,
    cx: 116.615,
    fill: "none",
    strokeWidth: 5.102
  })), /*#__PURE__*/React.createElement("circle", {
    r: 4.667,
    cy: 39.346,
    cx: 116.615,
    fill: "#00b087"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripadvisorIcon);
export default __webpack_public_path__ + "static/media/tripadvisor-icon.e398c196c9c7546ff23d44552cacf699.svg";
export { ForwardRef as ReactComponent };